import { render, staticRenderFns } from "./PrecosPorCm.vue?vue&type=template&id=2164490d&scoped=true"
import script from "./PrecosPorCm.vue?vue&type=script&lang=js"
export * from "./PrecosPorCm.vue?vue&type=script&lang=js"
import style0 from "./PrecosPorCm.vue?vue&type=style&index=0&id=2164490d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2164490d",
  null
  
)

export default component.exports